import EventManager from "../../../../manager/event_manager";
import Utility from "../../../../utility/utility";

const { ccclass, property } = cc._decorator;
@ccclass
export default class ActivityItem extends cc.Component {
    @property(cc.Node)
    nodeRedPoint: cc.Node = null

    @property(cc.Label)
    labelTitle: cc.Label = null

    @property(cc.Label)
    labelTitle_select: cc.Label = null

    @property(cc.Node)
    nodeBg: cc.Node = null

    @property(cc.Node)
    nodeBg_select: cc.Node = null

    @property(cc.Node)
    nodeButton: cc.Node = null

    protected m_data: any = null

    show(show: boolean, data?: any){
        this.node.active = !!show
        this.m_data = null
        if(show){
            this.m_data = data
            let selected = data.selected
            let title = data.activityName || data.title
            this.labelTitle.string = title
            this.labelTitle_select.string = title
            this.nodeBg.active = !selected
            this.nodeBg_select.active = !!selected
            this.nodeRedPoint.active = !data.hideRedPoint || !!data.isReceive || !!data.showRedPoint
            this.nodeButton.targetOff(this)
            this.nodeButton.on('click', function(){
                Utility.playButtonSound();
                EventManager.instance.dispatch('click_activity_item', data)
            }, this)
        }
    }

    protected on_refresh_redpoint(){
        if(this.m_data){
            this.nodeRedPoint.active = !this.m_data.hideRedPoint || !!this.m_data.isReceive || !!this.m_data.showRedPoint
        }
    }

    onLoad(){
        EventManager.instance.on('refresh_activity_redpoint', this.on_refresh_redpoint, this, true)
    }

    onDestroy(){
        EventManager.instance.off('refresh_activity_redpoint', this.on_refresh_redpoint, this)
    }
}